/**
 * Ayuda — Comercial → Descuentos y Promociones
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_COM_PROMOTIONS_ITEM = {
  id: 'promotions',
  screenId: 'adm-com-promotions',
  label: 'Descuentos y Promociones',
  description: 'Reglas de descuentos y regalos en ventas.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Las promociones aplican descuentos o regalos automáticamente al facturar o en la terminal de ventas (2×1, % de descuento, producto bonificado, etc.).',
      },
      {
        title: 'Ver la lista',
        fields: [
          {
            label: 'Mostrar',
            description: '«Vigentes» — solo las que están en fecha. «Todas» — incluye pasadas; con «Solo activas» filtrás las dadas de baja.',
          },
        ],
        bullets: [
          'Columnas: Nombre, Descripción, Inicio, Fin.',
          'Tocá una fila para ver el detalle.',
          'Lápiz — editar.',
        ],
      },
      {
        title: 'Cargar una promoción nueva',
        intro: 'El botón + abre el formulario. Los datos principales son:',
        fields: [
          { label: 'Nombre y descripción', description: 'Identifican la promoción internamente.' },
          { label: 'Prioridad', description: 'Si hay varias promociones, la de mayor prioridad se evalúa primero.' },
          { label: 'Fecha inicio / fin', description: 'Período de vigencia.' },
          { label: 'Aplicar automáticamente', description: 'Si está activo, se aplica sola al cumplir condiciones.' },
          { label: 'Acumulable', description: 'Si puede combinarse con otras promociones.' },
          { label: 'Activa', description: 'Desmarcá para pausar sin borrar.' },
        ],
      },
      {
        title: 'En qué se aplica y el beneficio',
        bullets: [
          'Alcance — toda la factura, líneas de productos, etc.',
          'Tipo de beneficio — porcentaje, monto fijo, precio fijo, producto de regalo, promoción X+Y (llevás X, regalás Y).',
        ],
      },
      {
        title: 'Filtros opcionales',
        intro:
          'Podés limitar la promoción a artículos, clientes o grupos específicos. Si no agregás filtros, aplica según el alcance elegido a todos los casos que cumplan.',
      },
    ],
  },
}
